export default __webpack_public_path__ + "static/media/Background_00003.c8732686.png";